import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { api } from '../api';
import { Storage } from '../constants';

@Injectable()
export class JobAlertService {

  private JobAlertsData: any[];

  saveJobAlert(data, isLoggedin) {
    if (isLoggedin) {
      return this.http.post(api.jobAlertPrivate.SAVE_JOB_ALERT_PRIVATE, data)
        .toPromise()
        .then(res => {
        this.JobAlertsData = null;
          return true;
        })
        .catch(this.handleError);
    } else {
      return this.http.post(api.public.jobAlert.SAVE_JOB_ALERT, data)
        .toPromise()
        .then(res => {
          return true;
        })
        .catch(this.handleError);
    }
  }

  private handleError(error: any) {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
  constructor(public http: HttpClient) { }

  isJobAlertEnabled() {
    return window.localStorage.getItem(Storage.ENABLE_JOB_ALERT) === 'True';
  }

  getJobAlerts() {

    return this.http.get<any[]>(api.candidate.GET_JOB_ALETS)
      .toPromise()
      .then(result => {
        this.JobAlertsData = result;
        return this.JobAlertsData;
      }).catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ../UI/src/app/shared/job-alert/job-alert.service.ts